"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeConfigs = mergeConfigs;
exports.isApiError = isApiError;
/**
 * Merges any number of configs together with the latter configs taking priority
 * over the former configs.
 *
 * @param configs the configs
 * @return the merged config
 */
function mergeConfigs(...configs) {
    if (configs.length === 0) {
        return {};
    }
    if (configs.length === 1) {
        return { ...configs[0] };
    }
    return mergeConfig(configs[0], mergeConfigs(...configs.slice(1)));
}
/**
 * Determines if the given error is a Broadleaf API Error.
 * @param error The request error of unknown type
 * @returns Whether the error is an ApiError
 */
function isApiError(error) {
    if (typeof error === 'undefined' || error === null) {
        return true;
    }
    if (typeof error === 'object' && error !== null) {
        return 'type' in error && 'title' in error && 'status' in error;
    }
    return false;
}
/**
 * Merges the two configs together with values in config2 taking priority over
 * values in config1.
 *
 * @param config1 the first config
 * @param config2 the second config
 * @return the merged config
 */
function mergeConfig(config1, config2) {
    if (!config1) {
        return { ...config2 };
    }
    if (!config2) {
        return { ...config1 };
    }
    const mergedConfig = { ...config1, ...config2 };
    if (config1.headers || config2.headers) {
        mergedConfig.headers = {
            ...config1.headers,
            ...config2.headers
        };
    }
    if (config1.params || config2.params) {
        mergedConfig.params = {
            ...config1.params,
            ...config2.params
        };
    }
    return mergedConfig;
}
//# sourceMappingURL=request-utils.js.map